import uuidv4 from 'uuid/v4';

import { Fragment, Slice } from '@atlaskit/editor-prosemirror/model';
import type { Node } from '@atlaskit/editor-prosemirror/model';

// When pasting an anchor extension, we need to ensure that the
// value of the macro param used as the anchor name is unique
export const ensureUniqueAnchorNamesOnPasteAction = (slice: Slice): Slice => {
	const updatedContent: Node[] = [];
	slice.content.forEach((node: Node) => {
		if (
			node.attrs.extensionType === 'com.atlassian.confluence.macro.core' &&
			node.attrs.extensionKey === 'anchor'
		) {
			// Update the value of the macro param used as anchor name (used as html id in UI) to a unique value, UUID.
			const newAttrs = {
				...node.attrs,
				parameters: {
					...node.attrs.parameters,
					macroParams: {
						...node.attrs.parameters.macroParams,
						'': {
							value: uuidv4(),
						},
					},
				},
			};
			updatedContent.push(node.type.create(newAttrs, node.content, node.marks));
		} else {
			updatedContent.push(node);
		}
	});
	return new Slice(Fragment.fromArray(updatedContent), slice.openStart, slice.openEnd);
};
